import { useEffect, useState, useContext } from 'react'

//components
import ResizableModal from '../../../../../ui/ResizableModal'
import { Button } from '../../../../../ui'
import LoaderMain from '../../../../../../../assets/svgIcons/loaderMain.json'
import GlobalContext from '../../../../../../../context/global-context'

// lottie
import Lottie from 'lottie-react'

//api
import { CentroCostosAPI } from '../../../../../../../api/centroCostos.api'

//mui
import { Box } from '@mui/material'

const ModalEdit = ({ open, handleClose, centroCostoId, onSuccess }) => {
  const [nombre, setNombre] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const { currentBusiness } = useContext(GlobalContext)
  const centroCostosAPI = new CentroCostosAPI()

  const getData = async () => {
    if (!open || !centroCostoId) return
    try {
      setIsLoading(true)

      const response = await centroCostosAPI.getOneCentroCosto(currentBusiness.id, centroCostoId)

      const centro = response.data
      setNombre(centro.name || '')
    } catch (error) {
      console.error('Error al obtener centro de costo', error)
    } finally {
      setIsLoading(false)
    }
  }

  // cuando abra el modal o cambie el id, vuelvo a cargar
  useEffect(() => {
    getData()
  }, [])

  const handleSave = async () => {
    try {
      const payload = { name: nombre }

      await centroCostosAPI.updateCentroCosto(currentBusiness.id, centroCostoId, payload)

      if (onSuccess) {
        await onSuccess() // refresca la lista en el padre
      }

      handleClose()
    } catch (error) {
      console.error('Error al actualizar centro de costo', error)
    }
  }

  return (
    <ResizableModal
      open={open}
      onClose={handleClose}
      width={1000}
      height={260}
      footer={
        <>
          <Button
            onClick={handleClose}
            className='uppercase text-sm bg-primary text-white rounded-full'
            title='cerrar'
          />
          <Button
            disabled={isLoading}
            onClick={handleSave}
            className='uppercase text-sm text-white rounded-full bg-accent2'
            title='guardar cambios'
          />
        </>
      }
    >
      <>
        {isLoading ? (
          <Box display='flex' justifyContent='center' alignItems='center' height='100%'>
            <Lottie animationData={LoaderMain} loop autoplay style={{ width: 100, height: 100 }} />
          </Box>
        ) : (
          <div className='px-6 py-4'>
            <h3 className='text-base font-semibold mb-4'>Editar Centro de Costos</h3>

            <div className='flex flex-col gap-2'>
              <label className='text-xs font-medium text-gray-600' htmlFor='nombreCentroCosto'>
                Nombre del Centro de Costo
              </label>
              <input
                id='nombreCentroCosto'
                type='text'
                value={nombre}
                onChange={e => setNombre(e.target.value)}
                className='border border-gray-300 rounded-full px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400'
                placeholder='Ingresa el nombre'
              />
            </div>
          </div>
        )}
      </>
    </ResizableModal>
  )
}

export default ModalEdit
